"use client";

import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import { Section, VStack } from "@/ui";

const STORAGE_URL = process.env.NEXT_PUBLIC_R2_PUBLIC_URL || "";

const VIDEO_SRC = `${STORAGE_URL}/media/videos/B404C078-4736-4A10-A36A-23ED08836AD7.MP4`;

export const GiftWrappingSection = () => {
  const giftWrappingT = useTranslations("gift_warpping");
  const videoRef = useRef<HTMLVideoElement>(null);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => {
      const reduce = mql.matches;
      setPrefersReducedMotion(reduce);
      if (reduce && videoRef.current) {
        videoRef.current.pause();
      }
    };
    sync();
    mql.addEventListener("change", sync);
    return () => mql.removeEventListener("change", sync);
  }, []);

  const allowMotionPlayback = !prefersReducedMotion;

  return (
    <Section
      id="wrapping"
      className="section-spacing bg-muted/20"
    >
      <VStack className="flex-col items-center justify-center gap-8 md:flex-row md:gap-16 lg:gap-24">
        <VStack className="max-w-sm flex-1 items-center text-center md:items-start md:text-start">
          <span className="section-label">{giftWrappingT("label")}</span>
          <h2 className="heading-display mt-3">{giftWrappingT("subtitle")}</h2>
          <p className="heading-sub mt-4">{giftWrappingT("description")}</p>
        </VStack>
        <VStack className="max-w-sm flex-1 justify-center">
          <div className="img-zoom aspect-[4/3] w-full overflow-hidden rounded-lg">
            <video
              ref={videoRef}
              aria-label={giftWrappingT("video_aria_label")}
              className="size-full rounded-lg object-contain"
              src={VIDEO_SRC}
              muted
              autoPlay={allowMotionPlayback}
              loop={allowMotionPlayback}
              playsInline
              controls
            />
          </div>
        </VStack>
      </VStack>
    </Section>
  );
};
